export default "__VITE_ASSET__DzQigrEM__"